/** i18n */
export default {
	// perform deep merge with new properties
	extend: function(obj){
		"use strict"; // :/
		$.extend(true, this, obj);
	},
	/**
	 * Get i8n text from dot notation path
	 * @param {string} stringKey
	 * @returns {string}
	 */
	get: function(stringKey){
		var o = this,
			_key = stringKey.replace(/\[(\w+)\]/g, '.$1');

		_key = _key.replace(/^\./, '');
		var a = _key.split('.');
		while (a.length) {
			let n = a.shift();
			if (n in o) {
				o = o[n];
			} else {
				return;
			}
		}
		return o;
	}
}